var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var metaMap = new Map();
var dialogTypeMap = new Map();
var dialogInstanceStack = [];
var activeDialogInstance = null;
/**
 * 遍历Vue的组件树，如果发现有CbDialog或者CbModal这类组件，需要增加锁定
 * @param instance
 * @returns
 */
function lockComponentsTree(instance) {
    if (!instance) {
        return;
    }
    var queue = [instance];
    while (queue.length) {
        var comp = queue.shift();
        if (typeof comp.lockScroll === "function") {
            comp.lockScroll();
            return;
        }
        if (Array.isArray(comp.$children)) {
            queue.push.apply(queue, __spreadArray([], __read(comp.$children), false));
        }
    }
}
/**
 * 遍历Vue的组件树，如果发现有CbDialog或者CbModal这类组件，需要解除锁定
 * @param instance
 * @returns
 */
function unlockComponentsTree(instance) {
    if (!instance) {
        return;
    }
    var queue = [instance];
    while (queue.length) {
        var comp = queue.shift();
        if (typeof comp.unlock === "function") {
            comp.unlock();
            return;
        }
        if (Array.isArray(comp.$children)) {
            queue.push.apply(queue, __spreadArray([], __read(comp.$children), false));
        }
    }
}
function waitRenderEnd(root) {
    var timer;
    var counter = 0;
    return new Promise(function (resolve) {
        timer = setInterval(function () {
            var isEl = root.$el.nodeType === 1;
            if (counter > 10) {
                clearInterval(timer);
                resolve(false);
                return;
            }
            if (isEl) {
                clearInterval(timer);
                resolve(true);
            }
            else {
                counter++;
            }
        }, 30);
    });
}
export default {
    install: function (Vue, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var store = options.store;
        /**
         * 将某个弹窗实例设置为显示
         * @param instance
         */
        var showAnyDialog = function (instance) {
            var _a;
            var el = instance.$el;
            var meta = metaMap.get(instance);
            el.style.display = meta.display || "block";
            typeof ((_a = instance.$refs.root) === null || _a === void 0 ? void 0 : _a.$options.onShow) === "function" && instance.$refs.root.$options.onShow.apply(instance.$refs.root);
            lockComponentsTree(instance);
        };
        /**
         * 打开一个弹窗
         * @param dialogType
         * @param params
         */
        var openDialog = function (dialogType, params, events) {
            if (params === void 0) { params = {}; }
            if (events === void 0) { events = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var preDestroy, _a, destroy, rest, thisInstance, oldInstance, outlet;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // 如果前一个弹窗还活跃，则需要先处理
                            if (activeDialogInstance) {
                                preDestroy = metaMap.get(activeDialogInstance).destroy;
                                // 确实不销毁， 将之前高亮的弹窗隐藏
                                if (preDestroy === false) {
                                    activeDialogInstance.$el.style.display = "none";
                                    unlockComponentsTree(activeDialogInstance);
                                    dialogInstanceStack.push(activeDialogInstance);
                                }
                                else {
                                    destroyDialog(false, false);
                                }
                                activeDialogInstance = null;
                            }
                            _a = Object.assign({ destroy: true }, params), destroy = _a.destroy, rest = __rest(_a, ["destroy"]);
                            oldInstance = dialogTypeMap.get(dialogType);
                            if (!!oldInstance) return [3 /*break*/, 2];
                            outlet = document.createElement("div");
                            outlet.classList.add("dialog");
                            document.body.appendChild(outlet);
                            thisInstance = new Vue({
                                store: store,
                                render: function (h) {
                                    return h(dialogType, {
                                        props: rest,
                                        attrs: rest,
                                        ref: "root",
                                        on: __assign(__assign({}, events), { close: closeAllDialog }),
                                    });
                                },
                            }).$mount(outlet);
                            // 等待元素的渲染完成
                            return [4 /*yield*/, waitRenderEnd(thisInstance)];
                        case 1:
                            // 等待元素的渲染完成
                            _b.sent();
                            // 设置元数据，再稍后将尝试寻找
                            metaMap.set(thisInstance, {
                                destroy: destroy,
                                dialogType: dialogType,
                                display: getComputedStyle(thisInstance.$el).display,
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            thisInstance = dialogTypeMap.get(dialogType);
                            // 把它从不是active弹窗调整到active上去
                            dialogInstanceStack = dialogInstanceStack.filter(function (x) { return x !== oldInstance; });
                            showAnyDialog(thisInstance);
                            _b.label = 3;
                        case 3:
                            // 设置或更新弹窗类型
                            dialogTypeMap.set(dialogType, thisInstance);
                            // 设置当前弹窗为活跃弹窗
                            activeDialogInstance = thisInstance;
                            return [2 /*return*/, { close: closeDialog, instance: thisInstance }];
                    }
                });
            });
        };
        /**
         * 关闭弹窗
         * @returns
         */
        var closeDialog = function (showPreDialog) {
            if (!activeDialogInstance) {
                console.log("your need hide or destroy dialog instance not exist");
                return;
            }
            // 尝试获取
            var destroy = (metaMap.get(activeDialogInstance) || {}).destroy;
            if (typeof destroy === "undefined") {
                destroy = true;
            }
            // 如果需要销毁的话，直接销毁就好，并且要把栈中存储的之前的弹窗打开
            if (destroy) {
                destroyDialog(showPreDialog);
            }
            else {
                // 如果发现被禁用滚动了的话，终止禁用
                unlockComponentsTree(activeDialogInstance);
                // 将弹窗的DOM隐藏，然后加入到堆栈中去
                var el = activeDialogInstance.$el;
                el.style.display = "none";
                dialogInstanceStack.push(activeDialogInstance);
                activeDialogInstance = null;
            }
        };
        /**
         * 销毁当前的活跃弹窗，是否需要自动填充前一个弹窗，是否展示前面一个弹窗
         * @returns
         */
        var destroyDialog = function (showPreDialog, extractPreDialogToFill) {
            if (extractPreDialogToFill === void 0) { extractPreDialogToFill = true; }
            if (!activeDialogInstance) {
                console.log("your need hide or destroy dialog instance not exist");
                return;
            }
            activeDialogInstance.$destroy();
            document.body.removeChild(activeDialogInstance.$el);
            var dialogType = (metaMap.get(activeDialogInstance) || {}).dialogType;
            // 删除配置的元数据，防止内存泄露
            metaMap.delete(activeDialogInstance);
            dialogTypeMap.delete(dialogType);
            if (dialogInstanceStack.length && extractPreDialogToFill) {
                activeDialogInstance = dialogInstanceStack.pop();
                // 将当前活跃的弹窗显示为活跃
                if (showPreDialog) {
                    showAnyDialog(activeDialogInstance);
                }
            }
            else {
                activeDialogInstance = null;
            }
        };
        /**
         * 关闭所有弹窗
         */
        var closeAllDialog = function () {
            while (activeDialogInstance) {
                destroyDialog(false);
            }
        };
        Vue.prototype.$closeAllDialog = closeAllDialog;
        Vue.prototype.$closeDialog = closeDialog;
        Vue.prototype.$openDialog = openDialog;
    },
};
